<template>
  <div class="dialog-batch-config g-jc-ai">
    <Form :model="academyData" :label-width="100" ref="editForm" :rules="validateRules">
      <FormItem label="院系名称：" prop="name">
        <Input v-model="academyData.name" :autofocus="true" placeholder="请输入院系名称" style="width:300px"></Input>
      </FormItem>
      <FormItem label="是否生效：" prop="status">
        <Select v-model="academyData.status" style="width:300px">
          <Option value="1">是</Option>
          <Option value="0">否</Option>
        </Select>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: 'academyConfig',
  props: {
    query: ''
  },
  data () {
    return {
      academyData: {
        id: '',
        name: '',
        status: ''
      },
      validateRules: {
        name: [{required: true, message: '院系名称不能为空', trigger: 'blur'}],
        status: [{required: true, message: '是否生效不能为空', trigger: 'blur'}]
      }
    }
  },
  created () {
    if (this.query) {
      this.fetchAcademyConfig();
    }
  },
  methods: {
    // 确定回调事件
    dialogComfirm () {
      return new Promise((resolve, reject) => {
        const _self = this;
        _self.$refs['editForm'].validate((valid) => {
          if (valid) {
            _self.post('/school/schoolAcademy/saveOrUpdate', {
              id: _self.academyData.id,
              name: _self.academyData.name,
              status: _self.academyData.status
            }).then(res => {
              _self.$Message.success(res.msg);
              resolve(res);
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    },
    fetchAcademyConfig () {
      const _self = this
      _self.fetch('/school/schoolAcademy/info/' + this.query).then(res => {
        _self.academyData = res.data
        _self.formLoading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/academyConfigEdit.vue